import { Box, Image, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { Product } from 'src/types/types'

interface DescriptionContentProps {
  product: Product
}

const DescriptionContent: React.FC<DescriptionContentProps> = ({ product }) => {
  return (
    <Box width='100%' maxHeight='80vh' overflowY='auto'>
      <VStack spacing={4} align='center'>
        <Image src={product?.images[0]?.src} alt={product?.name} boxSize='300px' />
        <Text fontSize='2xl' fontWeight='bold'>
          {product?.name}
        </Text>
        <Box
          dangerouslySetInnerHTML={{ __html: product?.short_description || '' }}
          marginBottom={5}
        />
        <Box dangerouslySetInnerHTML={{ __html: product?.description || '' }} />
      </VStack>
    </Box>
  )
}

export default DescriptionContent
